import { render, staticRenderFns } from "./adminList.vue?vue&type=template&id=4bfae0aa&scoped=true"
import script from "./adminList.vue?vue&type=script&lang=js"
export * from "./adminList.vue?vue&type=script&lang=js"
import style0 from "./adminList.vue?vue&type=style&index=0&id=4bfae0aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfae0aa",
  null
  
)

export default component.exports